export default {
  dev: {
    admin: 'http://surya.skordev.com/admin-dashboard/#/report',
    app: 'https://surya.skordev.com/',
    basePath: 'https://panasonicgobelindonesia-pwa.skordev.com/#/',
    img: 'https://surya.skordev.com',
  },
  prod: {
    admin: 'https://cerrapoints.com/admin-dashboard/#/report',
    app: 'https://cerrapoints.com/',
    basePath: 'https://panasonicecmshop.com/#/',
    img: 'https://cerrapoints.com',
  },
};
